import { BackOfficeDtoConverter } from 'shared/services/backoffice-data-provider';

import { ContentItem } from './models/ContentItem.model';

export class ActivitiesDtoConverter extends BackOfficeDtoConverter {
  convert(dto: any) {
    return ContentItem.fromDto(dto) as any;
  }
}
